// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7yYfI","content":"styles_content__AP_Ov","row":"styles_row__1JkPZ","footer":"styles_footer__3m3iZ","phraseLength":"styles_phraseLength__2SafN"};